export default {
	title: 'networks',
	components: [
		{ title: 'wifi_mode_client', component: 'wifi_mode_client_gen_2' },
		{
			title: 'outbound_websocket',
			component: 'outbound_ws',
			min_ver: '0.10.4',
		},
		{ title: 'cloud', component: 'cloud_gen_2' },
		{ title: 'mqtt', component: 'mqtt_gen_2' },
	],
};
